import {ReactElement, useEffect, useState} from "react";
import {useStripe} from '@stripe/react-stripe-js';
import ProjectSettingsLayout from "@/components/layouts/ProjectSettingsLayout";
import {createCustomer, createFreeSubscription, updateDefaultMethod} from "@/services/stripe-store"
import {useAuth} from "@/libs/auth";
import {useRouter} from "next/router";
import BillingPlans from "@/components/settings/billing/BillingPlans";
import BillingInfo from "@/components/settings/billing/BillingInfo";
import Invoices from "@/components/settings/billing/Invoices";
import BillingErrorModal from "@/components/settings/billing/modals/BillingErrorModal";
import BillingSuccessModal from "@/components/settings/billing/modals/BillingSuccessModal";
import SetDefaultPayments from "@/components/settings/billing/payment/SetDefaultPayments";
import {useTeam} from "@/libs/team";
import {updateUser} from "@/services/user-store";
import CreditUsage from "@/components/settings/billing/CreditUsage";


function Billing() {
  const {user, uid, loading, token} = useAuth();
  const {active} = useTeam()

  const router = useRouter();
  const stripe = useStripe();

  const [cid, setCid] = useState('');
  const [stripeLoading, setStripeLoading] = useState(false)

  const [errorMsg, setErrorMsg] = useState("");
  const [isErrorModal, setErrorModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [isSuccessModal, setSuccessModal] = useState(false);

  // handle case where user does to have customer iD
  useEffect(() => {
    if (!loading && active !== undefined) {
      // if user does not have a stripe customer id
      if ((active.cid == undefined || active.cid == "") && (user.cid == undefined || user.cid == "")) {
        createCustomer(token, {
          email: user.email,
          name: user.firstName + " " + user.lastName,
          phone: user.phone,
        }).then((res) => {
          const cid = res.data.id
          updateUser(uid, {cid: cid}).then(() => {
            createFreeSubscription(token, cid).then(() => {
              setTimeout(() => {
                setStripeLoading(true)
              }, 5000)
            }).catch((e) => {
              console.error(e)
            }).catch((e) => {
              console.error(e)
            })
          })

        })
      } else {
        setCid(active.cid)
        // setSubId(active.subId)
        setTimeout(() => {
          setStripeLoading(true)
        }, 500)
      }
    }
    // getUser(uid)
  }, [active, loading, token, uid, user]);

  // This useEffect is for when a user adds a new payment method
  useEffect(() => {
    if (!stripe) {
      return;
    }

    const {setup_intent_client_secret} = router.query;
    if (!setup_intent_client_secret || !cid) {
      return;
    }

    // @ts-ignore
    stripe.retrieveSetupIntent(setup_intent_client_secret)
      .then((result) => {
        const setupIntent = result.setupIntent;
        switch (setupIntent?.status) {
          case 'succeeded':
            // @ts-ignore
            updateDefaultMethod(token, setupIntent.payment_method);
            setSuccessMsg('Your payment method has been saved!');
            setSuccessModal(true);
            break;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [router, stripe, cid, token]);


  return (
    <div>
      {
        stripeLoading ? <div className="p-8 px-12 mt-6 flex flex-col bg-white rounded-md border border-gray-200">
          <h1 className="font-semibold text-3xl text-md">Billing</h1>
          <CreditUsage cid={cid}/>
          <BillingPlans cid={cid}/>
          <SetDefaultPayments cid={cid}/>
          <BillingInfo cid={cid}/>
          <Invoices cid={cid}/>
          <BillingErrorModal open={isErrorModal} close={() => setErrorModal(false)} errorMsg={errorMsg}/>
          <BillingSuccessModal open={isSuccessModal} close={() => setSuccessModal(false)} successMsg={successMsg}/>
        </div> : <div className="text-center">
          <div className="justify-center items-center py-32">
            Loading your billing information
            <div className="spinner">
              <div className="double-bounce1"></div>
              <div className="double-bounce2"></div>
            </div>
          </div>
        </div>
      }

    </div>

  )
}

Billing.getLayout = function getLayout(page: ReactElement) {
  return <ProjectSettingsLayout>{page}</ProjectSettingsLayout>;
};

export default Billing;
